
















































































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import AdminLayout from '@/modules/common/layout/components/admin/AdminLayout.vue'
import AdminUserTabularHeader from '@/modules/user/components/admin/AdminUserTabularHeader.vue'
import { adminUserTabularHeaderColumn } from '@/modules/user/models/columns/admin-user-tabular-header.column'
import BaseCard from '@/modules/shared/components/shared/base/BaseCard.vue'
import AdminUserIdentityForm from '@/modules/user/components/admin/forms/AdminUserIdentityForm.vue'
import AdminUserChangePasswordForm from '@/modules/user/components/admin/forms/AdminUserChangePasswordForm.vue'
import AdminUserBillingInfoForm from '@/modules/user/components/admin/forms/AdminUserBillingInfoForm.vue'
import AdminUserAccessibilityForm from '@/modules/role/components/admin/forms/AdminUserAccessibilityForm.vue'
import AdminUserShowSideNav from '@/modules/user/components/admin/AdminUserShowSideNav.vue'
import AdminUserWalletUpdateForm from '@/modules/wallet/components/admin/AdminUserWalletUpdateForm.vue'
import { WalletIndexResourceType, WalletType } from '@/modules/wallet/models/wallet-resource.model'
import AdminUserWalletLogTable from '@/modules/wallet-log/components/admin/table/AdminUserWalletLogTable.vue'
import AdminUserWalletLogSection from '@/modules/wallet-log/components/admin/AdminUserWalletLogSection.vue'
import SimpleHeader from '@/modules/shared/components/shared/SimpleHeader.vue'
import AdminWalletShowSideNavigation from '@/modules/wallet/components/admin/AdminWalletShowSideNavigation.vue'

@Component({
  layout: AdminLayout,
  layoutProps: {
    page_header: 'کیف پول کاربر'
  },
  metaInfo: {
    title: 'کیف پول کاربر'
  },
  components: {
    AdminWalletShowSideNavigation,
    SimpleHeader,
    AdminUserWalletLogSection,
    AdminUserWalletLogTable,
    AdminUserWalletUpdateForm,
    AdminUserShowSideNav,
    AdminUserAccessibilityForm,
    AdminUserBillingInfoForm,
    AdminUserChangePasswordForm,
    AdminUserIdentityForm,
    BaseCard,
    AdminUserTabularHeader
  }
})
export default class AdminUsersShowPage extends Vue {
  @Prop() user: WalletIndexResourceType
  private walletType = WalletType
  private isUpdated: boolean = false
  private walletAble = { writer: false, user: false }

  tabularColumns = adminUserTabularHeaderColumn(this.user.data)

  mounted() {
    this.walletShow()
  }

  updated() {
    this.isUpdated = false
  }

  onUpdate(isUpdated) {
    this.isUpdated = isUpdated
  }

  walletShow() {
    this.user.data.roles.forEach((item) => {
      this.walletAble[`${item.name}`] = true
    })
  }


}
